import * as React from 'react';
import { connect } from 'react-redux';
import isNil from 'lodash/isNil';

import Page from 'components/page/Page';
import BrandEditProfile from '../components/BrandEditProfile';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SettingsSidebar from 'modules/settings/SettingsSidebar';

import { t } from 'utils/language';
import { getBrandProfileId } from 'utils/organization';

import type { Organization } from 'types';

type StateProps = {
  currentOrganization: Organization
};

type OwnProps = {};
type Props = OwnProps & StateProps;

const BrandEditProfilePage = (
  {
    currentOrganization
  }: Props
): JSX.Element | null => {
  const brandProfileId = getBrandProfileId(currentOrganization);

  if (isNil(brandProfileId)) {
    return null;
  }

  return (
    <Page
      documentTitle={t('edit_profile_page')}
    >
      <SidebarPage
        scrollable
        sidebarWidth="narrow"
        sidebarContent={<SettingsSidebar />}
      >
        <BrandEditProfile profileId={brandProfileId} />
      </SidebarPage>
    </Page>
  );
};

const mapStateToProps = ({ organizations }): StateProps => ({
  currentOrganization: organizations.currentOrganization
});

export default connect(mapStateToProps)(BrandEditProfilePage);
